/**
 * Detects whether a string appears to be a PO Box address.
 * Strips all non-alphanumeric characters and checks if the result starts with "pobox" (case-insensitive).
 */
export function isPOBox(value: string): boolean {
    const cleaned = value.replace(/[^a-z0-9]/gi, '').toLowerCase()

    return cleaned.startsWith('pobox')
}

export function transformMonthDayYearStringToDate(
    _value: string,
    originalValue: string,
) {
    if (typeof originalValue !== 'string') return originalValue

    const ogValueDateArray = originalValue.split(' / ')

    if (ogValueDateArray.length !== 3) return null

    if (ogValueDateArray[2].length < 4) return null

    const newValue = new Date(
        `${ogValueDateArray[0]}/${ogValueDateArray[1]}/${ogValueDateArray[2]}`,
    )

    return newValue
}
